// @ts-nocheck
//ヘッダー
import Header from '../../component/page_parts/header';
// フッター
import Footer from '../../component/page_parts/footer';

// firebase
import firebase, { storage } from "../../firebase/firebase";

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import React, { useState, useRef, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
// import L from 'leaflet'
// L.Icon.Default.imagePath = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/'

function LunchmapEdit() {

  //テスト環境
  const baseUrl = process.env.REACT_APP_PUBLIC_URL || '';

  const genreList = [
    '和食',
    '洋食',
    '中華',
    'インド料理',
    '韓国料理',
    '台湾料理',
    'その他'
  ];
  const priceList = [
    '～500円',
    '501円～1,000円',
    '1,001円～1,500円',
    '1,501円～'
  ];

  // const genderCode = { f: '女性', m: '男性', n: 'それ以外' } as const;
  // interface FormData {
  //   shopName: string;
  //   zipcode?: string;
  //   gender?: keyof typeof genderCode;
  //   isAgreed: boolean;
  // }
  // const [formData, setFormData] = useState<FormData>({
  //   shopName: '',
  //   isAgreed: false,
  // });
  // 変換後の画像ファイルを管理
  const [convertedFile, setConvertedFile] = useState(null);

  // フォーム入力内容を保持
  const [formData, setFormData] = useState({
    shopName: '',
    genre01: false,
    genre02: false,
    genre03: false,
    genre04: false,
    genre05: false,
    genre06: false,
    genre07: false,
    price01: false,
    price02: false,
    price03: false,
    price04: false,
    review: '',
    // photos: null,
    // latitude: 0,
    // longitude: 0
  });


  // 初期表示の中心緯度経度（会社）
  const position = [35.69295732751798, 139.68788586609978];
  // 初期マップズームレベル
  const zoom = 17;

  // マーカーの処理(ドラッグ可能にして、ドラッグを離した地点の緯度経度をポップアップに表示)
  const [markerPosition, setMarkerPosition] = useState(L.latLng(position))
  const markerRef = useRef(null)
  // eventHandlers オブジェクトでイベント名と関数を渡す
  const eventHandlers = {
    // マーカーを掴んだ時に関数を実行
    dragstart: () => {
      const marker = markerRef.current;
      marker.setOpacity(0.6);
    },
    // マーカーを離した時に関数を実行
    dragend: () => {
      const marker = markerRef.current;
      marker.setOpacity(1);
      setMarkerPosition(marker.getLatLng());
      // console.log('marker.getLatLng(): ', marker.getLatLng());
      // console.log('marker.lat: ', marker.getLatLng().lat);
      // console.log('marker.lng: ', marker.getLatLng().lng);
    }
  }

  /**
   * フォーム入力時の処理
   */
  const handleChange = (e) => {
    // const { name } = e.target;
    const target = e.target;
    // console.log('e: ', e);
    // console.log('target: ', target);
    const name = target.id;
    // console.log('name: ', name);
    const value =
      target.type === 'checkbox'
        ? target.checked
        : target.value;
    // console.log('value: ', value);
    setFormData((state) => ({ ...state, [name]: value }));
  };

  // const handleImageUpload = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
  //   const file = e.target?.files?.[0];
  //   if (!file) {
  //     setConvertedFile(null);
  //     return;
  //   }
  //   // 選択されたファイルが画像ファイル以外だったらreturn
  //   if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
  //     // バリデーションメッセージ表示
  //     console.log('jpeg/pngファイルを選択してください');
  //     return;
  //   }
  //   const reader = new FileReader();
  //   // base64に変換
  //   reader.readAsDataURL(file);
  //   reader.onload = () => {
  //     // base64に変換した結果をstateにセットする
  //     setConvertedFile(reader.result);
  //     setFormData((state) => ({ ...state, photos: reader.result }));
  //   };
  // }, []);

  /**
   * 絵文字の文字化け対策
   * https://qiita.com/heppokofrontend/items/e77101f203598f4db729
   * https://blog.katsubemakito.net/html5/emoji2htmlentity
   * 
   * 文字列中のemojiをHTMLEntityへ変換する
   * @param {string} text
   * @return {string}
   */
  function convert(text) {
    const regex = emojiRegex();
    const convert = (emoji) => `&#x${emoji.codePointAt(0).toString(16)};`;
    let result = text;
    let match;
    while ( match = regex.exec(text) ) {
      const emoji = match[0];
      const htmlentity = convert(emoji);
      result = result.replace(emoji, htmlentity);
    }
    return(result);
  }
  /**
   * 絵文字の正規表現
   * - emoji-regexモジュールの正規表現を利用
   * @return {RegExp}
   * @copyright Copyright Mathias Bynens <https://mathiasbynens.be/>
   * @license the MIT license
   * @see https://github.com/mathiasbynens/emoji-regex
   */
  function emojiRegex() {
    // https://github.com/mathiasbynens/emoji-regex/blob/master/es2015/RGI_Emoji.js
    return /\u{1F3F4}\u{E0067}\u{E0062}(?:\u{E0077}\u{E006C}\u{E0073}|\u{E0073}\u{E0063}\u{E0074}|\u{E0065}\u{E006E}\u{E0067})\u{E007F}|\u{1F469}\u200D\u{1F469}\u200D(?:\u{1F466}\u200D\u{1F466}|\u{1F467}\u200D[\u{1F466}\u{1F467}])|\u{1F468}(?:\u{1F3FF}\u200D(?:\u{1F91D}\u200D\u{1F468}[\u{1F3FB}-\u{1F3FE}]|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|\u{1F3FE}\u200D(?:\u{1F91D}\u200D\u{1F468}[\u{1F3FB}-\u{1F3FD}\u{1F3FF}]|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|\u{1F3FD}\u200D(?:\u{1F91D}\u200D\u{1F468}[\u{1F3FB}\u{1F3FC}\u{1F3FE}\u{1F3FF}]|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|\u{1F3FC}\u200D(?:\u{1F91D}\u200D\u{1F468}[\u{1F3FB}\u{1F3FD}-\u{1F3FF}]|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|\u{1F3FB}\u200D(?:\u{1F91D}\u200D\u{1F468}[\u{1F3FC}-\u{1F3FF}]|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|\u200D(?:\u2764\uFE0F\u200D(?:\u{1F48B}\u200D)?\u{1F468}|[\u{1F468}\u{1F469}]\u200D(?:\u{1F466}\u200D\u{1F466}|\u{1F467}\u200D[\u{1F466}\u{1F467}])|\u{1F466}\u200D\u{1F466}|\u{1F467}\u200D[\u{1F466}\u{1F467}]|[\u{1F468}\u{1F469}]\u200D[\u{1F466}\u{1F467}]|[\u2695\u2696\u2708]\uFE0F|[\u{1F466}\u{1F467}]|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|(?:\u{1F3FF}\u200D[\u2695\u2696\u2708]|\u{1F3FE}\u200D[\u2695\u2696\u2708]|\u{1F3FD}\u200D[\u2695\u2696\u2708]|\u{1F3FC}\u200D[\u2695\u2696\u2708]|\u{1F3FB}\u200D[\u2695\u2696\u2708])\uFE0F|\u{1F3FF}|\u{1F3FE}|\u{1F3FD}|\u{1F3FC}|\u{1F3FB})?|\u{1F9D1}(?:[\u{1F3FB}-\u{1F3FF}]\u200D(?:\u{1F91D}\u200D\u{1F9D1}[\u{1F3FB}-\u{1F3FF}]|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F384}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|\u200D(?:\u{1F91D}\u200D\u{1F9D1}|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F384}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}]))|\u{1F469}(?:\u200D(?:\u2764\uFE0F\u200D(?:\u{1F48B}\u200D[\u{1F468}\u{1F469}]|[\u{1F468}\u{1F469}])|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|\u{1F3FF}\u200D[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}]|\u{1F3FE}\u200D[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}]|\u{1F3FD}\u200D[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}]|\u{1F3FC}\u200D[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}]|\u{1F3FB}\u200D[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|\u{1F469}\u{1F3FF}\u200D\u{1F91D}\u200D[\u{1F468}\u{1F469}][\u{1F3FB}-\u{1F3FE}]|\u{1F469}\u{1F3FE}\u200D\u{1F91D}\u200D[\u{1F468}\u{1F469}][\u{1F3FB}-\u{1F3FD}\u{1F3FF}]|\u{1F469}\u{1F3FD}\u200D\u{1F91D}\u200D[\u{1F468}\u{1F469}][\u{1F3FB}\u{1F3FC}\u{1F3FE}\u{1F3FF}]|\u{1F469}\u{1F3FC}\u200D\u{1F91D}\u200D[\u{1F468}\u{1F469}][\u{1F3FB}\u{1F3FD}-\u{1F3FF}]|\u{1F469}\u{1F3FB}\u200D\u{1F91D}\u200D[\u{1F468}\u{1F469}][\u{1F3FC}-\u{1F3FF}]|\u{1F469}\u200D\u{1F466}\u200D\u{1F466}|\u{1F469}\u200D\u{1F469}\u200D[\u{1F466}\u{1F467}]|(?:\u{1F441}\uFE0F\u200D\u{1F5E8}|\u{1F469}(?:\u{1F3FF}\u200D[\u2695\u2696\u2708]|\u{1F3FE}\u200D[\u2695\u2696\u2708]|\u{1F3FD}\u200D[\u2695\u2696\u2708]|\u{1F3FC}\u200D[\u2695\u2696\u2708]|\u{1F3FB}\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\u{1F3F3}\uFE0F\u200D\u26A7|\u{1F9D1}(?:[\u{1F3FB}-\u{1F3FF}]\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\u{1F43B}\u200D\u2744|(?:[\u{1F3C3}\u{1F3C4}\u{1F3CA}\u{1F46E}\u{1F470}\u{1F471}\u{1F473}\u{1F477}\u{1F481}\u{1F482}\u{1F486}\u{1F487}\u{1F645}-\u{1F647}\u{1F64B}\u{1F64D}\u{1F64E}\u{1F6A3}\u{1F6B4}-\u{1F6B6}\u{1F926}\u{1F935}\u{1F937}-\u{1F939}\u{1F93D}\u{1F93E}\u{1F9B8}\u{1F9B9}\u{1F9CD}-\u{1F9CF}\u{1F9D6}-\u{1F9DD}][\u{1F3FB}-\u{1F3FF}]|[\u{1F46F}\u{1F93C}\u{1F9DE}\u{1F9DF}])\u200D[\u2640\u2642]|[\u26F9\u{1F3CB}\u{1F3CC}\u{1F575}][\uFE0F\u{1F3FB}-\u{1F3FF}]\u200D[\u2640\u2642]|\u{1F3F4}\u200D\u2620|[\u{1F3C3}\u{1F3C4}\u{1F3CA}\u{1F46E}\u{1F470}\u{1F471}\u{1F473}\u{1F477}\u{1F481}\u{1F482}\u{1F486}\u{1F487}\u{1F645}-\u{1F647}\u{1F64B}\u{1F64D}\u{1F64E}\u{1F6A3}\u{1F6B4}-\u{1F6B6}\u{1F926}\u{1F935}\u{1F937}-\u{1F939}\u{1F93D}\u{1F93E}\u{1F9B8}\u{1F9B9}\u{1F9CD}-\u{1F9CF}\u{1F9D6}-\u{1F9DD}]\u200D[\u2640\u2642]|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u2600-\u2604\u260E\u2611\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26B0\u26B1\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0\u26F1\u26F4\u26F7\u26F8\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2763\u2764\u27A1\u2934\u2935\u2B05-\u2B07\u3030\u303D\u3297\u3299\u{1F170}\u{1F171}\u{1F17E}\u{1F17F}\u{1F202}\u{1F237}\u{1F321}\u{1F324}-\u{1F32C}\u{1F336}\u{1F37D}\u{1F396}\u{1F397}\u{1F399}-\u{1F39B}\u{1F39E}\u{1F39F}\u{1F3CD}\u{1F3CE}\u{1F3D4}-\u{1F3DF}\u{1F3F5}\u{1F3F7}\u{1F43F}\u{1F4FD}\u{1F549}\u{1F54A}\u{1F56F}\u{1F570}\u{1F573}\u{1F576}-\u{1F579}\u{1F587}\u{1F58A}-\u{1F58D}\u{1F5A5}\u{1F5A8}\u{1F5B1}\u{1F5B2}\u{1F5BC}\u{1F5C2}-\u{1F5C4}\u{1F5D1}-\u{1F5D3}\u{1F5DC}-\u{1F5DE}\u{1F5E1}\u{1F5E3}\u{1F5E8}\u{1F5EF}\u{1F5F3}\u{1F5FA}\u{1F6CB}\u{1F6CD}-\u{1F6CF}\u{1F6E0}-\u{1F6E5}\u{1F6E9}\u{1F6F0}\u{1F6F3}])\uFE0F|\u{1F469}\u200D\u{1F467}\u200D[\u{1F466}\u{1F467}]|\u{1F3F3}\uFE0F\u200D\u{1F308}|\u{1F469}\u200D\u{1F467}|\u{1F469}\u200D\u{1F466}|\u{1F415}\u200D\u{1F9BA}|\u{1F469}(?:\u{1F3FF}|\u{1F3FE}|\u{1F3FD}|\u{1F3FC}|\u{1F3FB})?|\u{1F1FD}\u{1F1F0}|\u{1F1F6}\u{1F1E6}|\u{1F1F4}\u{1F1F2}|\u{1F408}\u200D\u2B1B|\u{1F441}\uFE0F|\u{1F3F3}\uFE0F|\u{1F9D1}[\u{1F3FB}-\u{1F3FF}]?|\u{1F1FF}[\u{1F1E6}\u{1F1F2}\u{1F1FC}]|\u{1F1FE}[\u{1F1EA}\u{1F1F9}]|\u{1F1FC}[\u{1F1EB}\u{1F1F8}]|\u{1F1FB}[\u{1F1E6}\u{1F1E8}\u{1F1EA}\u{1F1EC}\u{1F1EE}\u{1F1F3}\u{1F1FA}]|\u{1F1FA}[\u{1F1E6}\u{1F1EC}\u{1F1F2}\u{1F1F3}\u{1F1F8}\u{1F1FE}\u{1F1FF}]|\u{1F1F9}[\u{1F1E6}\u{1F1E8}\u{1F1E9}\u{1F1EB}-\u{1F1ED}\u{1F1EF}-\u{1F1F4}\u{1F1F7}\u{1F1F9}\u{1F1FB}\u{1F1FC}\u{1F1FF}]|\u{1F1F8}[\u{1F1E6}-\u{1F1EA}\u{1F1EC}-\u{1F1F4}\u{1F1F7}-\u{1F1F9}\u{1F1FB}\u{1F1FD}-\u{1F1FF}]|\u{1F1F7}[\u{1F1EA}\u{1F1F4}\u{1F1F8}\u{1F1FA}\u{1F1FC}]|\u{1F1F5}[\u{1F1E6}\u{1F1EA}-\u{1F1ED}\u{1F1F0}-\u{1F1F3}\u{1F1F7}-\u{1F1F9}\u{1F1FC}\u{1F1FE}]|\u{1F1F3}[\u{1F1E6}\u{1F1E8}\u{1F1EA}-\u{1F1EC}\u{1F1EE}\u{1F1F1}\u{1F1F4}\u{1F1F5}\u{1F1F7}\u{1F1FA}\u{1F1FF}]|\u{1F1F2}[\u{1F1E6}\u{1F1E8}-\u{1F1ED}\u{1F1F0}-\u{1F1FF}]|\u{1F1F1}[\u{1F1E6}-\u{1F1E8}\u{1F1EE}\u{1F1F0}\u{1F1F7}-\u{1F1FB}\u{1F1FE}]|\u{1F1F0}[\u{1F1EA}\u{1F1EC}-\u{1F1EE}\u{1F1F2}\u{1F1F3}\u{1F1F5}\u{1F1F7}\u{1F1FC}\u{1F1FE}\u{1F1FF}]|\u{1F1EF}[\u{1F1EA}\u{1F1F2}\u{1F1F4}\u{1F1F5}]|\u{1F1EE}[\u{1F1E8}-\u{1F1EA}\u{1F1F1}-\u{1F1F4}\u{1F1F6}-\u{1F1F9}]|\u{1F1ED}[\u{1F1F0}\u{1F1F2}\u{1F1F3}\u{1F1F7}\u{1F1F9}\u{1F1FA}]|\u{1F1EC}[\u{1F1E6}\u{1F1E7}\u{1F1E9}-\u{1F1EE}\u{1F1F1}-\u{1F1F3}\u{1F1F5}-\u{1F1FA}\u{1F1FC}\u{1F1FE}]|\u{1F1EB}[\u{1F1EE}-\u{1F1F0}\u{1F1F2}\u{1F1F4}\u{1F1F7}]|\u{1F1EA}[\u{1F1E6}\u{1F1E8}\u{1F1EA}\u{1F1EC}\u{1F1ED}\u{1F1F7}-\u{1F1FA}]|\u{1F1E9}[\u{1F1EA}\u{1F1EC}\u{1F1EF}\u{1F1F0}\u{1F1F2}\u{1F1F4}\u{1F1FF}]|\u{1F1E8}[\u{1F1E6}\u{1F1E8}\u{1F1E9}\u{1F1EB}-\u{1F1EE}\u{1F1F0}-\u{1F1F5}\u{1F1F7}\u{1F1FA}-\u{1F1FF}]|\u{1F1E7}[\u{1F1E6}\u{1F1E7}\u{1F1E9}-\u{1F1EF}\u{1F1F1}-\u{1F1F4}\u{1F1F6}-\u{1F1F9}\u{1F1FB}\u{1F1FC}\u{1F1FE}\u{1F1FF}]|\u{1F1E6}[\u{1F1E8}-\u{1F1EC}\u{1F1EE}\u{1F1F1}\u{1F1F2}\u{1F1F4}\u{1F1F6}-\u{1F1FA}\u{1F1FC}\u{1F1FD}\u{1F1FF}]|[#\*0-9]\uFE0F\u20E3|[\u{1F3C3}\u{1F3C4}\u{1F3CA}\u{1F46E}\u{1F470}\u{1F471}\u{1F473}\u{1F477}\u{1F481}\u{1F482}\u{1F486}\u{1F487}\u{1F645}-\u{1F647}\u{1F64B}\u{1F64D}\u{1F64E}\u{1F6A3}\u{1F6B4}-\u{1F6B6}\u{1F926}\u{1F935}\u{1F937}-\u{1F939}\u{1F93D}\u{1F93E}\u{1F9B8}\u{1F9B9}\u{1F9CD}-\u{1F9CF}\u{1F9D6}-\u{1F9DD}][\u{1F3FB}-\u{1F3FF}]|[\u26F9\u{1F3CB}\u{1F3CC}\u{1F575}][\uFE0F\u{1F3FB}-\u{1F3FF}]|\u{1F3F4}|[\u270A\u270B\u{1F385}\u{1F3C2}\u{1F3C7}\u{1F442}\u{1F443}\u{1F446}-\u{1F450}\u{1F466}\u{1F467}\u{1F46B}-\u{1F46D}\u{1F472}\u{1F474}-\u{1F476}\u{1F478}\u{1F47C}\u{1F483}\u{1F485}\u{1F4AA}\u{1F57A}\u{1F595}\u{1F596}\u{1F64C}\u{1F64F}\u{1F6C0}\u{1F6CC}\u{1F90C}\u{1F90F}\u{1F918}-\u{1F91C}\u{1F91E}\u{1F91F}\u{1F930}-\u{1F934}\u{1F936}\u{1F977}\u{1F9B5}\u{1F9B6}\u{1F9BB}\u{1F9D2}-\u{1F9D5}][\u{1F3FB}-\u{1F3FF}]|[\u261D\u270C\u270D\u{1F574}\u{1F590}][\uFE0F\u{1F3FB}-\u{1F3FF}]|[\u270A\u270B\u{1F385}\u{1F3C2}\u{1F3C7}\u{1F408}\u{1F415}\u{1F43B}\u{1F442}\u{1F443}\u{1F446}-\u{1F450}\u{1F466}\u{1F467}\u{1F46B}-\u{1F46D}\u{1F472}\u{1F474}-\u{1F476}\u{1F478}\u{1F47C}\u{1F483}\u{1F485}\u{1F4AA}\u{1F57A}\u{1F595}\u{1F596}\u{1F64C}\u{1F64F}\u{1F6C0}\u{1F6CC}\u{1F90C}\u{1F90F}\u{1F918}-\u{1F91C}\u{1F91E}\u{1F91F}\u{1F930}-\u{1F934}\u{1F936}\u{1F977}\u{1F9B5}\u{1F9B6}\u{1F9BB}\u{1F9D2}-\u{1F9D5}]|[\u{1F3C3}\u{1F3C4}\u{1F3CA}\u{1F46E}\u{1F470}\u{1F471}\u{1F473}\u{1F477}\u{1F481}\u{1F482}\u{1F486}\u{1F487}\u{1F645}-\u{1F647}\u{1F64B}\u{1F64D}\u{1F64E}\u{1F6A3}\u{1F6B4}-\u{1F6B6}\u{1F926}\u{1F935}\u{1F937}-\u{1F939}\u{1F93D}\u{1F93E}\u{1F9B8}\u{1F9B9}\u{1F9CD}-\u{1F9CF}\u{1F9D6}-\u{1F9DD}]|[\u{1F46F}\u{1F93C}\u{1F9DE}\u{1F9DF}]|[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55\u{1F004}\u{1F0CF}\u{1F18E}\u{1F191}-\u{1F19A}\u{1F201}\u{1F21A}\u{1F22F}\u{1F232}-\u{1F236}\u{1F238}-\u{1F23A}\u{1F250}\u{1F251}\u{1F300}-\u{1F320}\u{1F32D}-\u{1F335}\u{1F337}-\u{1F37C}\u{1F37E}-\u{1F384}\u{1F386}-\u{1F393}\u{1F3A0}-\u{1F3C1}\u{1F3C5}\u{1F3C6}\u{1F3C8}\u{1F3C9}\u{1F3CF}-\u{1F3D3}\u{1F3E0}-\u{1F3F0}\u{1F3F8}-\u{1F407}\u{1F409}-\u{1F414}\u{1F416}-\u{1F43A}\u{1F43C}-\u{1F43E}\u{1F440}\u{1F444}\u{1F445}\u{1F451}-\u{1F465}\u{1F46A}\u{1F479}-\u{1F47B}\u{1F47D}-\u{1F480}\u{1F484}\u{1F488}-\u{1F4A9}\u{1F4AB}-\u{1F4FC}\u{1F4FF}-\u{1F53D}\u{1F54B}-\u{1F54E}\u{1F550}-\u{1F567}\u{1F5A4}\u{1F5FB}-\u{1F644}\u{1F648}-\u{1F64A}\u{1F680}-\u{1F6A2}\u{1F6A4}-\u{1F6B3}\u{1F6B7}-\u{1F6BF}\u{1F6C1}-\u{1F6C5}\u{1F6D0}-\u{1F6D2}\u{1F6D5}-\u{1F6D7}\u{1F6EB}\u{1F6EC}\u{1F6F4}-\u{1F6FC}\u{1F7E0}-\u{1F7EB}\u{1F90D}\u{1F90E}\u{1F910}-\u{1F917}\u{1F91D}\u{1F920}-\u{1F925}\u{1F927}-\u{1F92F}\u{1F93A}\u{1F93F}-\u{1F945}\u{1F947}-\u{1F976}\u{1F978}\u{1F97A}-\u{1F9B4}\u{1F9B7}\u{1F9BA}\u{1F9BC}-\u{1F9CB}\u{1F9D0}\u{1F9E0}-\u{1F9FF}\u{1FA70}-\u{1FA74}\u{1FA78}-\u{1FA7A}\u{1FA80}-\u{1FA86}\u{1FA90}-\u{1FAA8}\u{1FAB0}-\u{1FAB6}\u{1FAC0}-\u{1FAC2}\u{1FAD0}-\u{1FAD6}]/gu;
  }

  /**
   * フォーム送信時の処理
   */
  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log('formData: ', formData);

    // console.log('convertedFile: ', convertedFile);

    if (markerPosition.lat === position[0] && markerPosition.lng && position[1]) {
      alert('マップ上のマーカーをお店の位置にドラッグしてください');
    } else {
      // 分割代入
      const {
        shopName,
        genre01,
        genre02,
        genre03,
        genre04,
        genre05,
        genre06,
        genre07,
        price01,
        price02,
        price03,
        price04,
        review,
        // photos
      } = formData;

      // 更新用URLパラメータを作成
      const param =
        '?type=add' +
        '&shopName=' + encodeURIComponent(convert(shopName)) +
        '&latitude=' + markerPosition.lat +
        '&longitude=' + markerPosition.lng +
        '&genre=' +
        genre01 + ',' +
        genre02 + ',' +
        genre03 + ',' +
        genre04 + ',' +
        genre05 + ',' +
        genre06 + ',' +
        genre07 +
        '&price=' +
        price01 + ',' +
        price02 + ',' +
        price03 + ',' +
        price04 + ',' +
        '&review=' + encodeURIComponent(convert(review));
        // '&photos=' + photos;
      // console.log('param: ', param);

      // API
      fetch(process.env.REACT_APP_API_PATH + 'lunchmap/lunchmap.php' + param)
        .then((response) => response.json())
        .then((data) => {
          // console.log('data: ', data);
          alert("投稿しました");
        });
    }
  };

  return (
    <>
      <Header />
      <div className="theme-lunchmap-edit">
        <div className="content-header">
          <div className="container">
            <Row>
              <Col sm={12}>
                <h1 className='page-title type-briefcase'>【開発中】ランチ情報投稿ページβ版</h1>{/* ページタイトル */}
                <p className="page-description">ランチ情報の投稿ページです。<br />投稿いただいた内容が<Link to={baseUrl + '/lunchmap'}>ランチマップ</Link>に反映されます。</p>{/* ページの説明 */}
              </Col>
            </Row>
          </div>
        </div>
        <nav aria-label="breadcrumb" className="container">
          <ol className="breadcrumb my-m">
            <li className="breadcrumb-item"><Link to={baseUrl + '/'}>TOP</Link></li>
            <li className="breadcrumb-item"><Link to={baseUrl + '/lunchmap'}>ランチマップ</Link></li>
            <li className="breadcrumb-item active" aria-current="page">ランチ情報投稿ページ</li>
          </ol>
        </nav>
        <div className="container">
          <Row className='column-wrap'>
            <Col as='main' md={6} className='main-column'>
              <MapContainer center={position} zoom={zoom}>
                <TileLayer
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Marker
                  ref={markerRef}
                  position={markerPosition}
                  draggable={true}
                  eventHandlers={eventHandlers}
                >
                  {/* <Popup>
                    ドラッグを離した地点の緯度経度<br/>
                    {`${markerPosition.lat}, ${markerPosition.lng}`}
                  </Popup> */}
                </Marker>
              </MapContainer>
            </Col>
            <Col as='aside' md={6} className='side-column'>
              <Form onSubmit={handleSubmit} encType="multipart/form-data">
                <Form.Group as={Row} className="text-start mb-3" controlId="shopName">
                  <Form.Label column sm="3">
                    店名
                  </Form.Label>
                  <Col sm="9">
                    <input
                      type="text"
                      placeholder="店名を入力"
                      aria-label="店名記入欄"
                      id="shopName"
                      className="form-control"
                      value={formData.shopName}
                      onChange={handleChange}
                    />
                    {/* <Form.Control
                      type="text"
                      placeholder='店名を入力'
                      aria-label='店名記入欄'
                      value={formData.shopName}
                      onChange={handleChange}
                    /> */}
                  </Col>
                </Form.Group>

                <fieldset className="text-start row mb-3">
                  <legend className='col-sm-3 fs-6 pt-0'>
                    ジャンル
                  </legend>
                  <Col sm="9">
                    {['checkbox'].map((type) => (
                      <div key={`inline-${type}`} className="text-start">
                        {
                          genreList.map((genreName, index) => {
                            // indexを2桁で0埋め
                            const num = ('00' + (index + 1)).slice(-2);
                            // const genreArray = formData.genre.split(',');
                            // const genreItem = genreArray[index].split('=');
                            // let checked = false;
                            // // 該当ジャンルにチェックがあった場合のみ
                            // if(genreItem[1] === 'true') {
                            //   checked = true;
                            // }
                            return (
                              <div className="form-check form-check-inline" key={`genre-item${num}`}>
                                <input
                                  name="genre-group"
                                  type={type}
                                  id={`genre${num}`}
                                  className="form-check-input"
                                  onChange={handleChange}
                                // {...checked === true && 'checked'}
                                />
                                <label
                                  title=""
                                  htmlFor={`genre${num}`}
                                  className="form-check-label"
                                >
                                  {genreName}
                                </label>
                              </div>
                            )
                          })
                        }
                      </div>
                    ))}
                  </Col>
                </fieldset>

                <fieldset className="text-start row mb-3">
                  <legend className='col-sm-3 fs-6 pt-0'>
                    価格帯
                  </legend>
                  <Col sm="9">
                    {['checkbox'].map((type) => (
                      <div key={`inline-${type}`} className="text-start">
                        {
                          priceList.map((priceName, index) => {
                            // indexを2桁で0埋め
                            const num = ('00' + (index + 1)).slice(-2);
                            return (
                              <div className="form-check form-check-inline" key={`price-item${num}`}>
                                <input
                                  name="price-group"
                                  type={type}
                                  id={`price${num}`}
                                  className="form-check-input"
                                  onChange={handleChange}
                                // {...checked === true && 'checked'}
                                />
                                <label
                                  title=""
                                  htmlFor={`price${num}`}
                                  className="form-check-label"
                                >
                                  {priceName}
                                </label>
                              </div>
                            )
                          })
                        }
                      </div>
                    ))}
                  </Col>
                </fieldset>

                <Form.Group as={Row} className="text-start mb-3" controlId="review">
                  <Form.Label column sm="3">
                    コメント
                  </Form.Label>
                  <Col sm="9">
                    <textarea
                      rows="3"
                      aria-label="コメント記入欄"
                      id="review"
                      className="form-control"
                      value={formData.review}
                      onChange={handleChange}
                    />
                    {/* <Form.Control as="textarea" rows={3} aria-label='コメント記入欄' /> */}
                  </Col>
                </Form.Group>

                {/* <Form.Group as={Row} className="text-start mb-3" controlId="photos">
                  <Form.Label column sm="3">
                    写真<br/><small>※複数選択可</small>
                  </Form.Label>
                  <Col sm="9">
                    <Form.Control
                      type="file"
                      multiple
                      aria-label='写真アップロード（※複数選択可）'
                      accept="image/png, image/jpeg"
                      onChange={handleImageUpload}
                    />
                    {convertedFile !== null ? (
                      <img
                        src={convertedFile}
                        alt=""
                        width="100"
                        className='mt-2'
                      />
                      ) : ''
                    }
                  </Col>
                </Form.Group> */}

                <input type="hidden" id="markerLat" name="markerLat" value={markerPosition.lat} />
                <input type="hidden" id="markerLng" name="markerLng" value={markerPosition.lng} />

                <Button
                  variant="primary"
                  type="submit"
                  className="main-btn mt-4"
                >
                  お店を登録する
                </Button>
              </Form>

              <div className="btn-wrap text-center mt-5">
                <Link
                  to={baseUrl + '/lunchmap'}
                  className='btn btn-secondary px-5'
                >
                  ランチマップに戻る
                </Link>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <Footer />
    </>
  );




  // const [image, setImage] = useState("");
  // const [imageUrl, setImageUrl] = useState("");
  // const handleImage = event => {
  //   const image = event.target.files[0];
  //   // console.log(image);
  //   setImage(image);
  // };

  // const onSubmit = event => {
  //   event.preventDefault();
  //   if (image === "") {
  //     console.log("ファイルが選択されていません");
  //   }

  //   const date = new Date();
  //   const now = date.getFullYear() + ('0' + (date.getMonth() + 1)).slice(-2) + ('0' + date.getDate()).slice(-2) + '_' + ('0' + date.getHours()).slice(-2) + ('0' + date.getMinutes()).slice(-2) + ('0' + date.getSeconds()).slice(-2);
  //   // console.log(now);

  //   // アップロード処理
  //   const uploadTask = storage.ref(`/images/${now}_${image.name}`).put(image);
  //   uploadTask.on(
  //     firebase.storage.TaskEvent.STATE_CHANGED,
  //     next,
  //     error,
  //     complete
  //   );
  // };
  // const next = snapshot => {
  //   // 進行中のsnapshotを得る
  //   // アップロードの進行度を表示
  //   const percent = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
  //   console.log(percent + "% done");
  //   console.log(snapshot);
  // };
  // const error = error => {
  //   // エラーハンドリング
  //   console.log(error);
  // };
  // const complete = () => {
  //   // 完了後の処理
  //   // 画像表示のため、アップロードした画像のURLを取得
  //   storage
  //     .ref("images")
  //     .child(now + '_' + image.name)
  //     .getDownloadURL()
  //     .then(fireBaseUrl => {
  //       setImageUrl(fireBaseUrl);
  //     });
  // };
  // return (
  //   <div className="App">
  //     <h1>画像アップロード</h1>
  //     <form onSubmit={onSubmit}>
  //       <input type="file" onChange={handleImage} />
  //       <button>Upload</button>
  //     </form>
  //     { imageUrl !== "" ? (
  //       <img src={imageUrl} alt="uploaded" />
  //     ) : (
  //       <></>
  //     ) }
  //   </div>
  // );

}

export default LunchmapEdit;